var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSurvey = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 46,
  viewBox: "0 0 48 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 45.1948C37.2548 45.1948 48 35.0776 48 22.5974C48 10.1172 37.2548 0 24 0C10.7452 0 0 10.1172 0 22.5974C0 35.0776 10.7452 45.1948 24 45.1948Z",
  fill: "#BCD9C9"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 46
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 45.1948C37.2548 45.1948 48 35.0776 48 22.5974C48 10.1172 37.2548 0 24 0C10.7452 0 0 10.1172 0 22.5974C0 35.0776 10.7452 45.1948 24 45.1948Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 7.71429,
  y: 16.9481,
  width: 31.7143,
  height: 36.9776,
  rx: 3,
  fill: "#F1F6F4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6.75,
  y: 16.084,
  width: 34.5,
  height: 29.975,
  rx: 3.25,
  stroke: "#727D79",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 25.0184,
  width: 12.8571,
  height: 1.6141,
  rx: 0.80705,
  fill: "#999E9C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5595 22.8693C12.6218 22.5577 12.8954 22.3334 13.2132 22.3334H16.7868C17.1046 22.3334 17.3782 22.5577 17.4405 22.8693L17.4667 23H18.3334C19.4379 23 20.3334 23.8955 20.3334 25V33.6667C20.3334 34.7713 19.4379 35.6667 18.3334 35.6667H11.6667C10.5621 35.6667 9.66669 34.7713 9.66669 33.6667V25C9.66669 23.8955 10.5621 23 11.6667 23H12.5333L12.5595 22.8693ZM13.6264 24.3334L13.7598 23.6667H16.2403L16.3736 24.3334H13.6264ZM17.7333 24.3334L17.8405 24.8693C17.923 25.2818 17.6075 25.6667 17.1868 25.6667H12.8132C12.3925 25.6667 12.077 25.2818 12.1595 24.8693L12.2667 24.3334H11.6667C11.2985 24.3334 11 24.6319 11 25V33.6667C11 34.0349 11.2985 34.3334 11.6667 34.3334H18.3334C18.7015 34.3334 19 34.0349 19 33.6667V25C19 24.6319 18.7015 24.3334 18.3334 24.3334H17.7333Z",
  fill: "#EF7E18"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8925 27.5248C17.0137 27.4023 17.1789 27.3334 17.3513 27.3334C17.5238 27.3334 17.689 27.4024 17.8103 27.5249C18.0635 27.7791 18.0633 28.1867 17.8096 28.4406L14.4415 31.8092C14.1874 32.0635 13.7759 32.0636 13.5218 31.8092L12.1905 30.4764C11.9368 30.2225 11.9365 29.8149 12.1897 29.5607C12.311 29.4382 12.4762 29.3692 12.6487 29.3692C12.8211 29.3692 12.9863 29.4381 13.1076 29.5606L13.9832 30.4372L16.8925 27.5248Z",
  fill: "#EF7E18"
}), /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 29.0537,
  width: 12.8571,
  height: 1.6141,
  rx: 0.80705,
  fill: "#999E9C"
}), /*#__PURE__*/React.createElement("rect", {
  x: 28.2857,
  y: 33.0891,
  width: 8.57143,
  height: 1.6141,
  rx: 0.807049,
  fill: "#999E9C"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSurvey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/survey.9d9833af82a7ca5d0e1b0398b1d5498e.svg";